import { actions } from '../constants/notification';
import * as actionTypes from '../../models/action/notification';

export function GetNotifications(onlyUnread?: boolean, notificationPanelType?: number, take?: number, page?: number, showTopNotification?: boolean, callback?: any, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.IGetNotifications {
    return {
        onlyUnread,
        notificationPanelType,
        take,
        page,
        showTopNotification,
        timestamp: Date.now(),
        type: actions.GET_NOTIFICATIONS,
        spinnerId,
        spinnerType,
        callback
    };
}

export function SetNotifications(notifications?: actionTypes.INotification[], unreadNotificationCount?: number, isOnlyCount?: boolean, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.ISetNotifications {
    return {
        notifications,
        unreadNotificationCount,
        isOnlyCount,
        timestamp: Date.now(),
        type: actions.SET_NOTIFICATIONS,
        spinnerId,
        spinnerType
    };
}

export function GetActivityNotifications(onlyUnread?: boolean, notificationPanelType?: number, take?: number, page?: number, showTopNotification?: boolean, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.IGetActivityNotifications {
    return {
        onlyUnread,
        notificationPanelType,
        take,
        page,
        showTopNotification,
        timestamp: Date.now(),
        type: actions.GET_ACTIVITY_NOTIFICATIONS,
        spinnerId,
        spinnerType
    };
}

export function SetActivityNotifications(activityNotifications?: actionTypes.INotification[], activityUnreadNotificationCount?: number, activityIsOnlyCount?: boolean, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.ISetActivityNotifications {
    return {
        activityNotifications,
        activityUnreadNotificationCount,
        activityIsOnlyCount,
        timestamp: Date.now(),
        type: actions.SET_ACTIVITY_NOTIFICATIONS,
        spinnerId,
        spinnerType
    };
}

export function GetNotificationsAll(onlyUnread?: boolean, notificationPanelType?: number, take?: number, page?: number, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.IGetNotificationsALL {
    return {
        onlyUnread,
        notificationPanelType,
        take,
        page,
        timestamp: Date.now(),
        type: actions.GET_NOTIFICATIONS_ALL,
        spinnerId,
        spinnerType
    };
}

export function SetNotificationsALL(notificationsAll?: actionTypes.INotification[], unreadNotificationCountAll?: number, isOnlyCountAll?: boolean, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.ISetNotificationsALL {
    return {
        notificationsAll,
        unreadNotificationCountAll,
        isOnlyCountAll,
        timestamp: Date.now(),
        type: actions.SET_NOTIFICATIONS_ALL,
        spinnerId,
        spinnerType
    };
}

export function GetActivityNotificationsAll(onlyUnread?: boolean, notificationPanelType?: number, take?: number, page?: number, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.IGetActivityNotificationsALL {
    return {
        onlyUnread,
        notificationPanelType,
        take,
        page,
        timestamp: Date.now(),
        type: actions.GET_ACTIVITY_NOTIFICATIONS_ALL,
        spinnerId,
        spinnerType
    };
}

export function SetActivityNotificationsALL(activityNotificationsAll?: actionTypes.INotification[], activityUnreadNotificationCountAll?: number, activityIsOnlyCountAll?: boolean, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.ISetActivityNotificationsALL {
    return {
        activityNotificationsAll,
        activityUnreadNotificationCountAll,
        activityIsOnlyCountAll,
        timestamp: Date.now(),
        type: actions.SET_ACTIVITY_NOTIFICATIONS_ALL,
        spinnerId,
        spinnerType
    };
}

export function GetReadNotifications(callback?: (value: any) => void, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.IGetReadNotifications {
    return {
        callback,
        timestamp: Date.now(),
        type: actions.GET_READ_NOTIFICATIONS,
        spinnerId,
        spinnerType
    };
}

export function GetReadNotificationId(notificationId: string, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.IGetReadNotificationId {
    return {
        notificationId,
        timestamp: Date.now(),
        type: actions.GET_READ_NOTIFICATION_ID,
        spinnerId,
        spinnerType
    };
}

export function GetReadActivityNotifications(spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.IGetReadActivityNotifications {
    return {
        timestamp: Date.now(),
        type: actions.GET_READ_ACTIVITY_NOTIFICATIONS,
        spinnerId,
        spinnerType
    };
}